export default __webpack_public_path__ + "static/media/img-0566-finland-half-face.14a7ea05.png";